import { Actions, ActionTypes } from '@appStore/account/actions';
import { UserNotificationChannel } from '@model';

export interface State {
  loadingChannels: boolean;
  loadedChannels: boolean;
  updatingChannels: boolean;
  updatedChannels: boolean;
  updatingChannel: boolean;
  updatedChannel: boolean;
  data: UserNotificationChannel[];
}

export const initialState: State = {
  loadingChannels: false,
  loadedChannels: false,
  updatingChannels: false,
  updatedChannels: false,
  updatingChannel: false,
  updatedChannel: false,
  data: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.UserNotificationChannelsLoadData:
      return { ...state, loadedChannels: false, loadingChannels: true };
    case ActionTypes.UserNotificationChannelsLoadDataSuccess:
      return { ...state, loadedChannels: true, loadingChannels: false, data: action.payload };
    case ActionTypes.UserNotificationChannelsLoadDataFail:
      return { ...state, loadedChannels: false, loadingChannels: false };

    case ActionTypes.UserNotificationChannelUpdateItems:
      return { ...state, updatedChannels: false, updatingChannels: true };
    case ActionTypes.UserNotificationChannelUpdateItemsSuccess:
      return { ...state, updatedChannels: true, updatingChannels: false, data: action.payload };
    case ActionTypes.UserNotificationChannelUpdateItemsFail:
      return { ...state, updatedChannels: false, updatingChannels: false };

    case ActionTypes.UserNotificationChannelUpdateItem:
        return { ...state, updatedChannel: false, updatingChannel: true };
    case ActionTypes.UserNotificationChannelUpdateItemSuccess:
        let updatedItem = action.payload;
        return { ...state,
          updatedChannel: true,
          updatingChannel: false,
          data: state.data.map(item => (item.notificationArea === updatedItem.notificationArea 
              ? updatedItem 
              : item)) // Could be default or UserSetting
        };
    case ActionTypes.UserNotificationChannelUpdateItemFail:
        return { ...state, updatedChannel: false, updatingChannel: false };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getLoadedChannels = (state: State) => state.loadedChannels;
export const getLoadingChannels = (state: State) => state.loadingChannels;
export const getUpdatedChannels = (state: State) => state.updatedChannels;
export const getUpdatingChannels = (state: State) => state.updatingChannels;
export const getUpdatedChannel = (state: State) => state.updatedChannel;
export const getUpdatingChannel = (state: State) => state.updatingChannel;
